
function castValues(fieldValue, ruleValue, valueType) {
    let castedFieldValue = fieldValue;
    let castedRuleValue = ruleValue;

    if (valueType === 'number') {
        castedFieldValue = fieldValue != null ? Number(fieldValue || 0) : NaN;
        castedRuleValue = Array.isArray(ruleValue)
            ? ruleValue.map(v => Number(v || 0))
            : Number(ruleValue || 0);

        if (isNaN(castedFieldValue) || (Array.isArray(castedRuleValue) && castedRuleValue.some(isNaN))) {
            return { castedFieldValue: null, castedRuleValue: null };
        }
    }
    // else if(valueType === 'date'){
    //     castedFieldValue = fieldValue != null ? new Date(fieldValue) : null;
    //     castedRuleValue = Array.isArray(ruleValue)
    //         ? ruleValue.map(v => new Date(v))
    //         : new Date(ruleValue);
    //     if(isNaN(castedFieldValue.getTime()) || (Array.isArray(castedRuleValue) && castedRuleValue.some(isNaN))) {
    //         return { castedFieldValue: null, castedRuleValue: null };
    //     }
    // }
    // else if (valueType === 'boolean') {
    //     castedFieldValue = fieldValue != null ? Boolean(fieldValue) : false;
    //     castedRuleValue = Array.isArray(ruleValue)
    //         ? ruleValue.map(v => Boolean(v))
    //         : Boolean(ruleValue);

    //     if (isNaN(castedFieldValue) || (Array.isArray(castedRuleValue) && castedRuleValue.some(isNaN))) {
    //         return { castedFieldValue: null, castedRuleValue: null };
    //     }
    // }
    else {
        castedFieldValue = fieldValue != null ? [null, undefined].includes(fieldValue)?fieldValue:String(fieldValue) : '';
        castedRuleValue = Array.isArray(ruleValue)
            ? ruleValue.map(v => [null, undefined].includes(v) ? v : String(v))
            : [null, undefined].includes(ruleValue) ? ruleValue : String(ruleValue);
    }

    return { castedFieldValue, castedRuleValue };
}

function compareValues(fieldValue, ruleValue, operator, valueType, value2 = null, previousValue = undefined) {
    switch (operator) {
        case 'equals':
        case 'eq':
            return fieldValue === ruleValue;
        case 'ne':
        case 'not_equals':
            return fieldValue !== ruleValue;
        case 'greater_than':
            return valueType === 'number' ? fieldValue > ruleValue : String(fieldValue) > String(ruleValue);
        case 'less_than':
            return valueType === 'number' ? fieldValue < ruleValue : String(fieldValue) < String(ruleValue);
        case 'greater_than_equal':
            return valueType === 'number' ? fieldValue >= ruleValue : String(fieldValue) >= String(ruleValue);
        case 'less_than_equal':
            return valueType === 'number' ? fieldValue <= ruleValue : String(fieldValue) <= String(ruleValue);
        case 'in':
            return Array.isArray(ruleValue) && ruleValue.includes(fieldValue);
        case 'not_in':
            return Array.isArray(ruleValue) && !ruleValue.includes(fieldValue);
        case 'not':
            return Array.isArray(fieldValue)?!fieldValue.length: !fieldValue;
        case 'is_exist':
            return Array.isArray(fieldValue)
                ? fieldValue.length > 0
                : typeof fieldValue === 'string'
                    ? fieldValue.length > 0
                    : typeof fieldValue === 'number' && fieldValue > 0;
        case 'is_null':
            return fieldValue === null;
        case 'is_not_null':
            return fieldValue !== null;
        case 'is_empty':
            return [null, undefined, ""].includes(fieldValue);
        case 'is_not_empty':
            return ![null, undefined, ""].includes(fieldValue);
        case 'is_boolean':
            return typeof fieldValue === 'boolean';
        case 'is_not_boolean':
            return typeof fieldValue !== 'boolean';
        case 'is_number':
            return typeof fieldValue === 'number';
        case 'is_not_number':
            return typeof fieldValue !== 'number';
        case 'is_string':
            return typeof fieldValue === 'string';
        case 'is_not_string':
            return typeof fieldValue !== 'string';
        case 'is_date':
            return typeof fieldValue === 'date';
        case 'is_not_date':
            return typeof fieldValue !== 'date';
        case 'is_array':
            return Array.isArray(fieldValue);
        case 'is_not_array':
            return !Array.isArray(fieldValue);
        case 'contains':
            return String(fieldValue).includes(String(ruleValue));
        case 'not_contains':
            return !String(fieldValue).includes(String(ruleValue));
        case 'includes':
            return Array.isArray(fieldValue) && fieldValue.includes(ruleValue);
        case 'excludes':
            return Array.isArray(fieldValue) && !fieldValue.includes(ruleValue);
        case 'starts_with':
            return String(fieldValue).startsWith(String(ruleValue));
        case 'ends_with':
            return String(fieldValue).endsWith(String(ruleValue));
        case 'regex':
            return new RegExp(ruleValue).test(String(fieldValue));
        case 'before':
            return new Date(fieldValue).getTime() < new Date(ruleValue).getTime();
        case 'same_as':
            return new Date(fieldValue).getTime() === new Date(ruleValue).getTime();
        case 'after':
            return new Date(fieldValue).getTime() > new Date(ruleValue).getTime();
        case 'between': {
            const dateMs = new Date(fieldValue).getTime();
            return dateMs >= new Date(ruleValue).getTime() && dateMs <= new Date(value2).getTime();
        }
        case 'changed':
            return fieldValue !== previousValue;
        case 'changed_from':
            return previousValue === ruleValue && fieldValue !== ruleValue;
        case 'changed_to':
            return previousValue !== ruleValue && fieldValue === ruleValue;
        default:
            console.warn(`Unknown operator: ${operator}`);
            return false;
    }
}

function getRuleFieldValue(data, fieldPath) {
    const keys = fieldPath.split('.');
    let current = data;

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        const isArray = key.endsWith('[]');

        if (isArray) {
            key = key.slice(0, -2); // remove []
            current = current?.[key];

            if (!Array.isArray(current)) {
                return undefined;
            }

            const remainingPath = keys.slice(i + 1).join('.');
            return current.map(item => getRuleFieldValue(item, remainingPath));
        }

        if (Array.isArray(current)) {
            // Apply remaining path to each item in the array
            const remainingPath = keys.slice(i).join('.');
            return current.map(item => getRuleFieldValue(item, remainingPath));
        }

        if (current && typeof current === 'object') {
            current = current[key];
        } else {
            return undefined;
        }
    }

    return current;
}


export const conditionRuleOperators = [
    { label: "Equals", value: "eq" },
    { label: "Not Equals", value: "ne" },
    { label: "Greater Than", value: "greater_than" },
    { label: "Less Than", value: "less_than" },
    { label: "Greater Than or Equal", value: "greater_than_equal" },
    { label: "Less Than or Equal", value: "less_than_equal" },
    { label: "In", value: "in" },
    { label: "Not In", value: "not_in" },
    { label: "Not", value: "not" },
    { label: "Is Exist", value: "is_exist" },
    { label: "Is Null", value: "is_null" },
    { label: "Is Not Null", value: "is_not_null" },
    { label: "Is Empty", value: "is_empty" },
    { label: "Is Not Empty", value: "is_not_empty" },
    { label: "Is Boolean", value: "is_boolean" },
    { label: "Is Not Boolean", value: "is_not_boolean" },
    { label: "Is Number", value: "is_number" },
    { label: "Is Not Number", value: "is_not_number" },
    { label: "Is String", value: "is_string" },
    { label: "Is Not String", value: "is_not_string" },
    { label: "Is Date", value: "is_date" },
    { label: "Is Not Date", value: "is_not_date" },
    { label: "Is Array", value: "is_array" },
    { label: "Is Not Array", value: "is_not_array" },
    { label: "Contains", value: "contains" },
    { label: "Not Contains", value: "not_contains" },
    { label: "Includes (array)", value: "includes" },
    { label: "Excludes (array)", value: "excludes" },
    { label: "Starts With", value: "starts_with" },
    { label: "Ends With", value: "ends_with" },
    { label: "Regex", value: "regex" },
    { label: "Before", value: "before" },
    { label: "Same As", value: "same_as" },
    { label: "After", value: "after" },
    { label: "Between", value: "between" },
    { label: "Changed", value: "changed" },
    { label: "Changed From", value: "changed_from" },
    { label: "Changed To", value: "changed_to" },
];

export function evaluateRules(rules, operator, data) {
    try{
    if (!rules.length) {
        console.warn('No rules provided, defaulting to true');
        return true;
    }

    const evaluateRule = (rule) => {
        const clonedData = JSON.parse(JSON.stringify(data)) || {};
        const fieldValue = getRuleFieldValue(clonedData,rule.field);
        const valueType = rule.type || 'string';

        // Cast values based on type
        const { castedFieldValue, castedRuleValue } = castValues(fieldValue, rule.value, valueType);
        if (castedFieldValue === null || castedRuleValue === null) {
            return false;
        }

        return compareValues(castedFieldValue, castedRuleValue, rule.operator, valueType);
    };

    const result = operator === 'AND' ? rules.every(evaluateRule) : rules.some(evaluateRule);
    return result;
    }catch(e){
        return false;
    }
}

